import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import clubReducer from './slices/clubSlice';
import cardReducer from './slices/cardSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clubs: clubReducer,
    cards: cardReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;